import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {Image, Text, StyleSheet, View, Pressable} from 'react-native';
import {openPage} from 'utils/mediafire';
import {getHost} from 'utils/platform';
import {colors} from 'config/styles';
import images from 'config/images';

import * as app from 'store/slices/app';

export function MenuAccount() {
  const {t} = useLingui();
  const host = getHost();
  const name = useSelector(app.selectors.getName);
  const email = useSelector(app.selectors.getEmail);
  const userAvatar = useSelector(app.selectors.getAvatar);

  const gotoAvatar = useCallback(() => openPage('myaccount/customize_avatar.php'), []);

  return (
    <View style={[styles.root, !email && styles.rootTrial]}>
      {email &&
        <Pressable onPress={gotoAvatar}>
          <Image
            style={styles.avatar}
            source={{uri: userAvatar}}
            defaultSource={{uri: images.avatar}}
            resizeMode="cover"
          />
        </Pressable>
      }
      <View style={styles.info}>
        <Text style={styles.name} numberOfLines={1}>
          {email ? name : t`Trial Account`}
        </Text>
        {email &&
          <Text style={styles.email} numberOfLines={1}>
            {email}
          </Text>
        }
        {!email &&
          <View>
            <Text style={styles.trial}>
              {t`This account is not registered to an email address. Unregistered accounts may be considered abandoned after 14 days of inactivity, unless you register.`}
            </Text>
            <Pressable onPress={() => openPage(`${host}/upgrade/`)}>
              <Text style={styles.trialUpsell}>
                {t`Register now.`}
              </Text>
            </Pressable>
          </View>
        }
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    marginHorizontal: 20,
    marginTop: 14,
    marginBottom: 4,
  },
  rootTrial: {
    flexDirection: 'column',
  },
  info: {
    marginLeft: 12,
  },
  avatar: {
    borderRadius: 3,
    height: 36,
    width: 36,
  },
  email: {
    width: 128,
    fontSize: 12,
    color: colors.neutral.mid,
  },
  name: {
    width: 100,
    fontSize: 14,
    marginBottom: 3,
    color: colors.neutral.white,
  },
  trial: {
    fontSize: 11,
    color: colors.secondary.yellow,
  },
  trialUpsell: {
    fontSize: 12,
    color: colors.secondary.yellow,
    textDecorationColor: colors.secondary.yellow,
    textDecorationLine: 'underline',
  },
});
